import { PopOverMenu } from "components/popups/PopOverMenu";
import { IGroup } from "components/popups/PopOverMenu/PopOverMenu";
import { memo } from "react";

interface INicheMoreMenu {
  isOpen: boolean;
  anchorEl: Element | null;
  onClose: () => void;
  menuItems: IGroup[];
}

export const NicheMoreMenu: React.FC<INicheMoreMenu> = memo((props) => {
  return (
    <PopOverMenu
      className="NicheMoreMenu"
      title="Options"
      {...props}
    />
  );
});
